import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OwnAiTitle } from '@/pages/Onboarding/Layouts/OwnAI/components/Title';
import { FLIRTING_STYLE_OPTIONS } from '@/pages/Onboarding/options/FlirtingStyle/FLIRTING_STYLE_OPTIONS';
import { getFlirtingStyleTitleById } from '@/pages/Onboarding/options/FlirtingStyle/utils/getFlirtingStyle';
import { OnbOptionType } from '@/pages/Onboarding/types.ts';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import {
  PurpleOptions,
  PurpleOptionItem,
} from '../../components/PurpleOptions';
import { LayoutDataType } from '../../types';

export const FlirtingStyleScreen: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'FlirtingStyle',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();

  const flirtingStyle = form.watch('flirting_style');

  const handleSelect = (
    option: OnbOptionType<LayoutDataType['flirting_style']>,
  ) => {
    form.setValue('flirting_style', option.id);
  };

  const handleNextStep = () => {
    const flirtingStyleTitle = getFlirtingStyleTitleById(flirtingStyle);
    userService.createOrUpdate({
      onboarding_data: {
        flirting_style: flirtingStyleTitle,
      },
    });
    wizard.nextStep();
  };

  return (
    <OnboardingPage background={'purple-gradient'}>
      <OnboardingNavigation />
      <OwnAiTitle>What's His Flirting Style?</OwnAiTitle>

      <IonContent>
        <PurpleOptions displayType="list">
          {FLIRTING_STYLE_OPTIONS.map((option) => (
            <PurpleOptionItem
              checked={flirtingStyle === option.id}
              control={form.control}
              option={option}
              name="flirting_style"
              key={option.id}
              onChange={() => handleSelect(option)}
              displayType="list"
            />
          ))}
        </PurpleOptions>
      </IonContent>
      <OnboardingFooter
        onContinue={handleNextStep}
        buttonColor={'purple-gradient'}
        buttonRadius={'sm'}
        buttonSize={'large'}
        buttonClassName={'page-footer'}
        disabled={!flirtingStyle}
      />
    </OnboardingPage>
  );
};
